"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobile = require("../../utils/mobile.utils");
var _NativeOption = require("./NativeOption");
var _CustomOption = require("./CustomOption");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Option = function Option(props) {
  if ((0, _mobile.isMobile)()) {
    return /*#__PURE__*/_react.default.createElement(_NativeOption.NativeOption, props);
  }
  return /*#__PURE__*/_react.default.createElement(_CustomOption.CustomOption, props);
};
exports.Option = Option;